import { Component, effect, forwardRef, input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Group, SelectedGroups } from './group';
import { MiqCheckboxMultigroupParent } from './miq-checkbox-multigroup-parent';
import { MatMenuTrigger, MatMenu, MatMenuContent } from '@angular/material/menu';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { CheckboxgroupComponent } from './checkboxgroup/checkboxgroup.component';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-checkbox-multigroup',
  templateUrl: './miq-checkbox-multigroup-component.html',
  styleUrl: './miq-checkbox-multigroup-component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MiqCheckboxMultigroupComponent),
      multi: true,
    },
  ],
  imports: [MatMenuTrigger, MatInput, MatIcon, MatMenu, MatMenuContent, CheckboxgroupComponent],
})
export class MiqCheckboxMultigroupComponent implements ControlValueAccessor, MiqCheckboxMultigroupParent {
  groups = input<Group[]>([]);
  readonly selectedgroupsInput = input<SelectedGroups[]>([], { alias: 'selectedgroups' });
  selectedgroups: SelectedGroups[] = [];
  readonly parentApi: MiqCheckboxMultigroupParent = this;
  groupsd: Group[] = [];
  selectedgroupsd: SelectedGroups[] = [];
  displayLabel: string = '';
  onChange = (value: Group[]) => {};
  onTouch = () => {};
  constructor() {
    effect(() => {
      const v = this.selectedgroupsInput();
      if (v !== undefined) {
        this.selectedgroups = v;
        this.updateChanges(false, true);
      }
    });
    effect(() => {
      this.groups();
      this.updateChanges(true, false);
    });
  }
  writeValue(obj: SelectedGroups[]): void {
    this.selectedgroups = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  updateChanges(groupUpdate: boolean, selectedGroupsUpdate: boolean) {
    if (groupUpdate) {
      this.groupsd = JSON.parse(JSON.stringify(this.groups()));
    }
    if (selectedGroupsUpdate) {
      this.selectedgroupsd = JSON.parse(JSON.stringify(this.selectedgroups));
    }
    this.groupsd.forEach(group => {
      if (group.NestedGroup) {
        group.NestedGroup?.forEach(subgroup => {
          this.selectedgroupsd?.forEach(selection => {
            if (subgroup.key === selection['key']) {
              subgroup['completed'] = true;
            }
          });
        });
      }
    });
    this.groupsd.forEach(group => {
      this.selectedgroupsd?.forEach(selection => {
        if (group.key === selection['key']) {
          group.completed = true;
        }
      });
    });
    this.getGroupCount();
  }
  getSelectedGroupPayload() {
    let selectedGroupPayload: Group[] = [];
    this.groupsd.forEach(item => {
      if (item.completed) {
        selectedGroupPayload.push({
          key: item.key,
          value: item.value,
        });
        item.NestedGroup?.filter(ns => ns.completed)
          .map(l => {
            const { key, value } = l;
            return { key, value };
          })
          .forEach(subgroup => selectedGroupPayload.push(subgroup));
      }
    });
    return selectedGroupPayload;
  }
  getGroupCount() {
    setTimeout(() => {
      const selectedGroupPayloadCount = this.getSelectedGroupPayload().map((it: { value: any }) => it.value);
      const len = selectedGroupPayloadCount.length;
      if (len > 1) this.displayLabel = `${selectedGroupPayloadCount[0]} (+${len - 1}) `;
      else if (len == 1) this.displayLabel = selectedGroupPayloadCount[0];
      else this.displayLabel = '';
    }, 0);
    return this.displayLabel;
  }
}
